import { useState } from 'react'
import { Clock, Calendar, ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Loading } from '@/components/ui/loading'
import { useAttendanceStats, useAttendanceCalendar } from '@/hooks'
import { cn, formatDate } from '@/utils'

const weekDays = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

export function AttendancePage() {
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const year = currentMonth.getFullYear()
  const month = currentMonth.getMonth() + 1

  const { data: statsData, isLoading: isStatsLoading } = useAttendanceStats()
  const { data: calendarData, isLoading: isCalendarLoading } = useAttendanceCalendar(year, month)

  const isLoading = isStatsLoading || isCalendarLoading

  // Mock stats for display
  const stats = statsData || {
    total_work_hours: 176,
    stats: { present: 22, late: 0, absent: 0, overtime: 2 }
  }

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <Clock className="w-6 h-6 text-orange-500" />
              考勤管理
            </h1>
            <p className="text-slate-500 dark:text-slate-400 mt-1">
              查看考勤记录、打卡状态和统计数据
            </p>
          </div>
        </div>
        <Loading className="py-20" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <Clock className="w-6 h-6 text-orange-500" />
            考勤管理
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1">
            查看考勤记录、打卡状态和统计数据
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="icon">
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <span className="text-sm font-medium px-4">
            {currentMonth.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long' })}
          </span>
          <Button variant="outline" size="icon">
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="pt-6">
            <div className="text-2xl font-bold text-slate-900 dark:text-white">22</div>
            <p className="text-sm text-slate-500">出勤天数</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="text-2xl font-bold text-green-600">0</div>
            <p className="text-sm text-slate-500">迟到次数</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="text-2xl font-bold text-rose-600">0</div>
            <p className="text-sm text-slate-500">缺勤次数</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="text-2xl font-bold text-indigo-600">2</div>
            <p className="text-sm text-slate-500">加班天数</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>考勤日历</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-7 gap-2">
            {weekDays.map((day) => (
              <div key={day} className="text-center text-sm font-medium text-slate-500 py-2">
                {day}
              </div>
            ))}
            {Array.from({ length: 35 }).map((_, i) => (
              <div
                key={i}
                className={cn(
                  'aspect-square rounded-lg border border-slate-200 dark:border-slate-800 p-2',
                  'hover:bg-slate-50 dark:hover:bg-slate-800/50 cursor-pointer'
                )}
              >
                <span className="text-sm">{(i % 30) + 1}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
